import { CustomersListModal } from "./CustomersListModal";
import { Col, Row, Modal, InputRef, Input, Tooltip } from "antd";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getCustomers } from "../../../../api/customers";
import { useMutation } from "react-query";
import Title from "../../../UI/Title/Title";
import { AddCustomer } from "./addCustomer";
import AddButton from "../../../UI/AddButton/addbutton";
import ResetButton from "../../../UI/ResetButton/resetbutton";
import { Search } from "../../../UI/Search/Search";
import { useRef } from "react";
import SearchIcon from "@mui/icons-material/Search";
type PropsType = {
  isCustomerOpen: boolean;
  setIsCustomerOpen: Dispatch<SetStateAction<boolean>>;
};

function CustomersModal({ isCustomerOpen, setIsCustomerOpen }: PropsType) {
  const [t] = useTranslation("common");
  const [openCustomer, setOpenCustomer] = useState(false);
  const [, setSearchText] = useState("");
  const [tableKey, setTableKey] = useState(0);
  const [page, setPage] = useState<number>(1);
  const [search, setSearch] = useState<string>("");
  const [customers, setCustomers] = useState<{}[]>([]);
  const { mutateAsync: getCutomersMutation, isLoading: isCustomersLoading } =
    useMutation(
      "customers",
      (body: { limit: number; q: string }) => getCustomers(body),
      {
        onSuccess: (record) => {
          setCustomers(record.data.data);
        },
      }
    );
  const resetFilters = () => {
    setTableKey((tableKey) => tableKey + 1);
    getCutomersMutation({ limit: page * 5 + 5, q: "" }).then((res) => {
      setCustomers(res.data.data);
      setSearchText("");
      setSearch("");
    });
  };

  useEffect(() => {
    //First load
    getCutomersMutation({ limit: page * 5 + 5, q: search });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const searchRef = useRef<InputRef>(null);
  useEffect(() => {
    if (isCustomerOpen) {
      setTimeout(() => {
        searchRef.current?.focus();
      }, 0);
    }
  }, [isCustomerOpen]);

  return (
    <>
      <Modal
        centered
        width={1100}
        open={isCustomerOpen}
        closable={false}
        maskClosable={false}
        onCancel={() => {
          setIsCustomerOpen(false);
          document.body.classList.remove("body-scroll-lock");
        }}
        okButtonProps={{ style: { display: "none" } }}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            height: "40px",
            width: "100px",
          },
        }}
        cancelText={t('cancel')}
      >
        <Row gutter={[0, 10]}>
          <Col span={24}>
            <Title title={`${t("loyalty-customers")}`} />
          </Col>
          <Col
            span={24}
            style={{ marginBottom: "20px" }}
            className="modaltitleEdit"
          >
            {t("please-select-a-customer-for-invoice")}
          </Col>
          <Col span={6}>
            <Input
              className="search"
              placeholder={`${t("search")}`}
              value={search}
              ref={searchRef}
              onChange={(e: any) => {
                setSearch(e.target.value);
                if (e.target.value === "") {
                  getCutomersMutation({ limit: page * 5 + 5, q: "" });
                }
              }}
              suffix={
                <Tooltip>
                  <SearchIcon
                    style={{
                      fontSize: "20px",
                      color: "#BDBDBD",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      getCutomersMutation({ limit: page * 5 + 5, q: search });
                    }}
                  />
                </Tooltip>
              }
              onPressEnter={() => {
                getCutomersMutation({ limit: page * 5 + 5, q: search });
              }}
            />
          </Col>
          <Col
            style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
            span={2}
            offset={16}
          >
            <Col>
              <ResetButton
                onClick={() => {
                  resetFilters();
                }}
              />
            </Col>
            <AddButton
              onClick={() => {
                setOpenCustomer(true);
              }}
            />
          </Col>
          <CustomersListModal
            customers={customers}
            loading={isCustomersLoading}
            tableKey={tableKey}
            setIsCustomersListOpen={setIsCustomerOpen}
            page={page}
            setPage={setPage}
            search={search}
            setCustomers={setCustomers}
            getCutomersMutation={getCutomersMutation}
          />
        </Row>
      </Modal>
      <AddCustomer
        page={page}
        search={search}
        openCustomer={openCustomer}
        setOpenCustomer={setOpenCustomer}
        getCutomersMutation={getCutomersMutation}
        setCustomers={setCustomers}
      />
    </>
  );
}

export default CustomersModal;
